/* unplugin-vue-components disabled */import { render } from "./Index.vue?vue&type=template&id=e26eac6e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=e26eac6e&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=e26eac6e&lang=scss&scoped=true"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e26eac6e"]])

export default __exports__